import React from 'react';
import { MERKMAL_LABEL } from '../fragenkatalog';
import { DreiWeg, Zahlfeld } from './GrundlagenBausteine';
// Die Merkmalsgruppen stehen in `merkmalGruppen.ts` — der Leitfaden zaehlt
// dieselbe Liste.
import { MERKMAL_GRUPPEN } from './merkmalGruppen';
import type { GrundlagenProps } from './typen';

/** Abschnitt „Projektmerkmale": die Ja/Nein/offen-Schalter in drei Gruppen,
 *  darunter Baujahr Bestand, Grabentiefe und Absturzhoehe. */
export const GrundlagenMerkmale: React.FC<GrundlagenProps> = ({
    merkmale, isReadOnly, onMerkmal, onZahl,
}) => (
    <section className="bg-white rounded-2xl border border-slate-200 p-5">
        <h3 className="font-bold text-slate-800 mb-1">Projektmerkmale</h3>
        <p className="text-xs text-slate-500 mb-4">
            Sie steuern, welche Fragen der Katalog stellt. <strong>„offen"</strong> lässt die
            zugehörigen Fragen stehen; nur ein ausdrückliches „Nein" blendet sie aus. Schneller geht es
            mit „Baubeschreibung auswerten (KI)" bei der Baubeschreibung.
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {MERKMAL_GRUPPEN.map(g => (
                <div key={g.titel}>
                    <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-2">{g.titel}</h4>
                    <div className="divide-y divide-slate-100">
                        {g.keys.map(k => (
                            <DreiWeg
                                key={String(k)}
                                label={MERKMAL_LABEL[String(k)] || String(k)}
                                wert={merkmale[k] as boolean | undefined}
                                disabled={isReadOnly}
                                onChange={w => onMerkmal(k, w)}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>

        <div className="mt-5 pt-4 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <Zahlfeld
                label="Baujahr Bestand"
                wert={merkmale.bestandBaujahr}
                disabled={isReadOnly}
                onChange={w => onZahl('bestandBaujahr', w)}
                hinweis="Vor dem 31.10.1993: Asbestvermutung"
            />
            <Zahlfeld
                label="Größte Baugruben-/Grabentiefe"
                einheit="m"
                wert={merkmale.grabentiefeM}
                disabled={isReadOnly}
                onChange={w => onZahl('grabentiefeM', w)}
                hinweis="Über 5 m: Anhang II Nr. 1"
            />
            <Zahlfeld
                label="Größte Absturzhöhe"
                einheit="m"
                wert={merkmale.absturzhoeheM}
                disabled={isReadOnly}
                onChange={w => onZahl('absturzhoeheM', w)}
                hinweis="Über 7 m: Anhang II Nr. 1"
            />
        </div>
    </section>
);
